import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'

interface GeneralFormData {
	nombreApellido: string
	email: string
	telefono: string
	empresa?: string
	descripcion: string
	tipoSeguro?: string
}

interface GeneralConfirmationScreenProps {
	onBack: () => void
	onClose: () => void
	data: GeneralFormData
}

export function GeneralConfirmationScreen({
	onBack,
	onClose,
	data,
}: GeneralConfirmationScreenProps) {
	return (
		<div className="flex h-full w-full flex-col">
			<div className="flex flex-1 flex-col items-center justify-center gap-6">
				<div className="flex size-20 items-center justify-center rounded-full bg-green-100">
					<Icon name="check" className="size-10 text-green-600" />
				</div>

				<div className="flex flex-col items-center gap-3">
					<h1 className="font-parkinsans text-center text-2xl font-medium text-blue-800 md:text-3xl">
						¡Solicitud enviada!
					</h1>
					<p className="max-w-md text-center text-neutral-600">
						Gracias por contactarnos, <strong>{data.nombreApellido}</strong>.
						Recibimos tu solicitud y nuestro equipo se pondrá en contacto con
						vos a la brevedad.
					</p>
				</div>

				<div className="w-full max-w-md rounded-xl bg-neutral-50 p-4">
					<h3 className="mb-3 text-sm font-medium text-neutral-700">
						Resumen de tu solicitud
					</h3>
					<div className="flex flex-col gap-2 text-sm">
						{data.tipoSeguro && (
							<div className="flex justify-between">
								<span className="text-neutral-500">Tipo de seguro:</span>
								<span className="font-medium text-neutral-700">
									{data.tipoSeguro}
								</span>
							</div>
						)}
						<div className="flex justify-between">
							<span className="text-neutral-500">Email:</span>
							<span className="font-medium text-neutral-700">{data.email}</span>
						</div>
						<div className="flex justify-between">
							<span className="text-neutral-500">Teléfono:</span>
							<span className="font-medium text-neutral-700">
								{data.telefono}
							</span>
						</div>
						{data.empresa && (
							<div className="flex justify-between">
								<span className="text-neutral-500">Empresa:</span>
								<span className="font-medium text-neutral-700">
									{data.empresa}
								</span>
							</div>
						)}
					</div>
				</div>

				<div className="flex items-center gap-2 text-sm text-neutral-500">
					<Icon name="clock" className="size-4" />
					<span>Te contactaremos en las próximas 24-48 horas hábiles</span>
				</div>
			</div>

			<div className="flex w-full shrink-0 flex-col items-center justify-start gap-2 bg-white pt-4 md:flex-row md:justify-between md:bg-transparent md:pt-8">
				<Button
					variant="primary"
					appearance="ghost"
					size="l"
					onClick={onBack}
					className="order-2 w-full gap-2 rounded-xl px-4 py-3 text-sm leading-4 md:order-1 md:w-auto md:px-6 md:py-4 md:text-base md:leading-5"
				>
					<Icon name="arrow-left" className="size-4" />
					Nueva cotización
				</Button>
				<Button
					variant="secondary"
					appearance="solid"
					size="l"
					onClick={onClose}
					className="order-1 w-full md:order-2 md:w-auto"
				>
					Volver al inicio
				</Button>
			</div>
		</div>
	)
}
